import { api } from 'src/api/axios';
import {
  SubscriptionPlan,
  PaymentMethod,
  AddPaymentMethodPayload,
  InvoiceSummary,
  InvoiceDetail,
  Subscription,
} from './interfaces/billing.interface';

export const getActiveSubscriptionPlans = async () => {
  const { data } = await api.get<SubscriptionPlan[]>(
    '/user/subscription-plans/active'
  );
  return data;
};

export const getSubscriptions = async () => {
  const { data } = await api.get<Subscription[]>(
    '/user/subscriptions/active'
  );
  return data;
}

export const getSubscriptionPlans = async () => {
  const { data } = await api.get<SubscriptionPlan[]>(
    '/user/subscription-plans'
  );
  return data;
};

export const getPaymentMethods = async () => {
  const { data } = await api.get<PaymentMethod[]>(
    '/user/payment/payment-methods'
  );
  return data;
};

export const addPaymentMethod = async (payload: AddPaymentMethodPayload) => {
  const { data } = await api.post<PaymentMethod>(
    '/user/payment/payment-methods',
    payload
  );
  return data;
};

export const getInvoices = async () => {
  const { data } = await api.get<InvoiceSummary[]>(
    '/user/payment/billing'
  );
  return data;
};

export const getInvoice = async (invoiceId: string) => {
  const { data } = await api.get<InvoiceDetail>(
    `/user/payment/billing/${invoiceId}`
  );
  return data;
};

export const updateSubscriptionPaymentMethod = async (
  subscriptionId: number,
  paymentMethodId: string
) => {
  const { data } = await api.patch(
    `/user/subscriptions/${subscriptionId}/payment-method`,
    { paymentMethodId }
  );
  return data;
};

